export default __webpack_public_path__ + "static/cleanshot-d228ba3075fddbf53246f897f83e53b7.png";